import crudHandlers from './_crud'

const initialState = {
  entities: [],
  is_fetching: false,
}

export default (state = initialState, action) => {
  return crudHandlers(state, action, 'route_management')
}
